import type { PrimaryEntityId } from "building-types/doc/primaryEntityId";
import type { DocEntityBase } from "building-types/entities/docEntityBase";
import { objectTypedKeys } from "common/utils/objectTypedKeys";
import type { DocEntityType } from "../doc/docEntityTypes";
import type { ForeignEntityId } from "../handles/foreignEntityId";

export interface EntitySettings extends DocEntityBase<"ENTITY_SETTINGS"> {
  readonly id: PrimaryEntityId<"ENTITY_SETTINGS">;
  readonly entityId: ForeignEntityId<EntityTypesEligibleForEntitySettings>;
  readonly referencedEntityType: EntityTypesEligibleForEntitySettings;
  readonly settingsOrSettingsSetId: ForeignEntityId<"SETTINGS_SET" | "SETTINGS">;
}

export type EntityTypesEligibleForEntitySettings = Extract<
  DocEntityType,
  "ROOF_OPENING" | "OPENING" | "ROOF" | "DORMER" | "ROOM" | "FLOOR" | "FOUNDATION"
>;

export type EligibleEntitySettingEntity = DocEntityBase<EntityTypesEligibleForEntitySettings>;

export const entitiesEligibleForEntitySettings: {
  [key in EntityTypesEligibleForEntitySettings]: true;
} = {
  DORMER: true,
  ROOF_OPENING: true,
  OPENING: true,
  ROOF: true,
  ROOM: true,
  FLOOR: true,
  FOUNDATION: true,
} as const;

export const entityTypesEligibleForEntitySettings = objectTypedKeys(entitiesEligibleForEntitySettings);
